import React from "react"
import { Helmet } from "react-helmet"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import IntegrationDetail from "../../../components/integrations/IntegrationDetail"
import { lumaData } from "../../../components/integrations/data/lumaData"
import ThumbnailImage from "../../../images/thumbnails/premagic-web-square.png"

const LumaIntegrationPage: React.FC = () => {
  const { seo } = lumaData

  return (
    <Layout
      title={seo.title}
      description={seo.description}
      keywords={seo.keywords}
      metaImage={ThumbnailImage}
    >
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords.join(", ")} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta
          name="canonical"
          content="https://premagic.com/integrations/luma/"
        />
      </Helmet>
      <Header />
      <IntegrationDetail data={lumaData} />
    </Layout>
  )
}

export default LumaIntegrationPage
